module.exports = __webpack_public_path__ + "images/emoji/disappointed.cf99a2c0b00ac19e812a.png";